import React, { useEffect } from 'react';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import { Box, Card, Grid, InputAdornment, Paper, TextField, Typography } from '@mui/material';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { createState, useState, Downgraded } from '@hookstate/core';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import moment from 'moment';
import TimeSelector from '../../sharedcomponents/timeSelector/timeSelector';
import UserCheckList from '../../sharedcomponents/userList/userCheckList';
import SearchIcon from '@mui/icons-material/Search'


const activitySate = createState({
    eventName: '',
    startDateTime: null,
    endDateTime: null,
    location: '',
    attire: '',
    notes: '',
});

const AddSubAcctivity = (props) => {
    // console.log("props", props);
    const state = useState(activitySate);
    const userInfo = useState(null);
    const eventData = useState(null);

    const [nameError, setNameErr] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const activityInfo = useState(null);
    const [disableBtn, setDisableBtn] = React.useState(true);
    const [selected, setSelected] = React.useState([]);
    const [search, setSearch] = React.useState('');
    const [users, setUsers] = React.useState([])

    useEffect(() => {
        const guserInfo = Helper.getStorage('userInfo');
        const eventInfo = Helper.getStorage('eventInfo');

        userInfo.set(guserInfo);
        if (
            eventData.get() == null ||
            (eventData.get() && eventData.eventID.value != eventInfo.eventID)
        ) {
            eventData.set(eventInfo);
        }
    }, []);
    useEffect(() => {
        activityInfo.set(props);
        if (props.activityInfo != null) {
            let info = props.activityInfo;
            // console.log("info.startDateTime", info.startDateTime);
            let editUserIds = []
            if (info.subActivityParticipants && info.subActivityParticipants.length > 0) {
                info.subActivityParticipants.map((vals) => {
                    editUserIds.push(vals.userID)
                })
            }
            setSelected(editUserIds)
            state.set({
                eventName: info.subActivityName,
                startDateTime:
                    info.startDateTime !== null && info.startDateTime !== undefined
                        ? moment(info.startDateTime).format('HH:mm')
                        : null,
                endDateTime:
                    info.endDateTime !== null && info.endDateTime !== undefined ? moment(info.endDateTime).format('HH:mm') : null,
                notes: info.notes,
            });
        } else {
            resetState();
        }
    }, [props.activityInfo]);
    useEffect(() => {
        handleDisableBtn();
    }, [state.get()]);
    const checkSelectedUsers = (selectedUsers) => {
        setSelected(selectedUsers);
    }
    useEffect(() => {
        if (props.users.length > 0 && users.length == 0) {
            setUsers(props.users);
        }
    }, [props.users])
    const handleOnSearchChange = (val) => {
        let value = val.replace(/^\s+/g, '');
        setSearch(value);
        let newUsers = [...props.users];
        if (value.length > 0) {
            newUsers = props.users.filter(x => x.name.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
                (x.roleName !== null && x.roleName.toLowerCase().indexOf(value.toLowerCase()) > -1) ||
                (x.userTags !== null && x.userTags.toLowerCase().indexOf(value.toLowerCase()) > -1))
            setUsers(newUsers)
        } else {
            setUsers([...props.users])
        }
    }
  
    const renderDialogContent = () => {
        return (
            <>
                <Box
                    component="form"
                    sx={{
                        width: '100%',
                    }}>
                    {props.activityInfo.activityName !== "" && props.activityInfo.activityName !== undefined && <Box sx={{ display: 'flex', justifyContent: 'left', p: 1 }}><Typography varient="subtitle2" sx={{ fontWeight: 500 }}>Activity Name: &nbsp;</Typography><Typography varient="body2"> {props.activityInfo.activityName}</Typography> </Box>}
                    <Box>
                        <TextField
                            required
                            fullWidth
                            type={'text'}
                            size="small"
                            value={state.get().eventName}
                            onChange={(e) =>
                                state.eventName.set(e.target.value)
                            }
                            id="outlined-required"
                            label="Sub Activity Name"
                            aria-errormessage="Sub Activity Name is required"
                            error={nameError}
                            onInput={(e) => {
                                e.target.value = e.target.value.slice(0, 200);
                                (e.target.value === "") ? setNameErr(true) : setNameErr(false)
                            }}
                        />
                    </Box>
                    <Box sx={{ width: '100%', marginTop: 1 }}>
                        <Grid
                            container
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid
                                item
                                lg={6}
                                md={6}
                                xs={12}
                                sx={{ width: '100%', marginTop: 1 }}>
                                {/* <LocalizationProvider
                                    dateAdapter={AdapterDateFns}>
                                    <DateTimePicker
                                        inputProps={{ readOnly: true }}
                                        label="Start Date & Time"
                                        value={state.startDateTime
                                            .attach(Downgraded)
                                            .get()}
                                        onChange={(newValue) => {
                                            state.startDateTime.set(newValue);
                                        }}
                                        cancelText
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                fullWidth
                                                size="small"
                                            />
                                        )}
                                    />
                                </LocalizationProvider> */}
                                <TimeSelector
                                    label='Start Time'
                                    value={state.startDateTime
                                        .attach(Downgraded)
                                        .get() == '00:00' ? null : state.startDateTime
                                        .attach(Downgraded)
                                        .get()}
                                    onChange={(newValue) => {
                                        state.startDateTime.set(newValue);
                                    }}
                                    errorMsg={''}
                                />
                            </Grid>

                            <Grid
                                item
                                lg={6}
                                md={6}
                                xs={12}
                                sx={{ width: '100%', marginTop: 1 }}>
                                {/* <LocalizationProvider
                                    dateAdapter={AdapterDateFns}>
                                    <DateTimePicker
                                        inputProps={{ readOnly: true }}
                                        label="End Date & Time"
                                        value={state.endDateTime
                                            .attach(Downgraded)
                                            .get()}
                                        onChange={(newValue) => {
                                            state.endDateTime.set(newValue);
                                        }}
                                        cancelText
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                fullWidth
                                                size="small"
                                            />
                                        )}
                                    />
                                </LocalizationProvider> */}
                                <TimeSelector
                                    label='End Time'
                                    value={state.endDateTime
                                        .attach(Downgraded)
                                        .get() === '00:00' ? null : state.endDateTime
                                        .attach(Downgraded)
                                        .get()}
                                    onChange={(newValue) => {
                                        state.endDateTime.set(newValue);
                                    }}
                                    errorMsg={''}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ width: '100%', marginTop: 1 }}>
                        <Grid
                            container
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid
                                item
                                lg={12}
                                md={12}
                                xs={12}
                                sx={{ width: '100%', marginTop: 1 }}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    multiline
                                    minRows={3}
                                    type={'text'}
                                    id="outlined-required"
                                    value={state.get().notes}
                                    onChange={(e) =>
                                        state.notes.set(e.target.value)
                                    }
                                    label="Notes"
                                    onInput={(e) => {
                                        e.target.value = e.target.value.slice(
                                            0,
                                            1000
                                        );
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ width: '100%', marginTop: 1 }}>
                        <Grid
                            container
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid
                                item
                                lg={12}
                                md={12}
                                xs={12}
                                sx={{ width: '100%', marginTop: 1 }}>
                                <Card sx={{ pt: 2 }}>
                                    <>
                                        <Box sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                            <TextField
                                                size="small"
                                                fullWidth={true}
                                                placeholder="Search Individuals"
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <SearchIcon />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                value={search}
                                                onChange={(event) => handleOnSearchChange(event.target.value)}
                                            />
                                        </Box>
                                        <Paper>
                                            <UserCheckList
                                                data={users}
                                                checkUsers={checkSelectedUsers}
                                                selectedUsers={selected}
                                                showRole={true}
                                            />
                                        </Paper>
                                    </>
                                </Card>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </>
        );
    };
    const renderDialogActions = () => {
        return (
            <ButtonContainer
                showLoading={true}
                loading={isLoading}
                handleClick={handleClick}
                handleCancel={props.handleClose}
                buttonText={props.activityInfo?.subActivityID ? 'Update' : 'Create'}
                disableUpdateButton={props.activityInfo ? disableBtn : false}
            />
        );
    };
    const handleDisableBtn = () => {
        if (props.activityInfo) {
            const data = props.activityInfo;
            let prevData = {
                activityName: data.activityName,
                startDateTime: data.startDateTime,
                endDateTime: data.endDateTime,
                notes: data.notes
            };

            let currentData = {
                activityName: state.get().eventName,
                startDateTime:
                    state.get().startDateTime !== null
                        ? moment(state.get().startDateTime).format('HH:mm')
                        : null,
                endDateTime:
                    state.get().endDateTime !== null
                        ? moment(state.get().endDateTime).format('HH:mm')
                        : null,
                notes: state.get().notes
            };
            if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                setDisableBtn(true);
            } else {
                setDisableBtn(false);
            }
        }
    };
    const handleClick = () => {
        // console.log("props.activityInfo", props.activityInfo);
        const eventName = state.get().eventName || '';
        var date1 = state.get().startDateTime !== null ? moment(state.get().startDateTime, 'h:mma') : null;
        var date2 = (state.get().endDateTime !== null && state.get().endDateTime !== '00:00') ? moment(state.get().endDateTime, 'h:mma') : null;
        // console.log("date2",date2,"date1",date1,"state.get().endDateTime",typeof state.get().endDateTime);
        if (eventName.trim() === '') {
            setNameErr(true);
            return;
        } else if (date1 === null && date2 !== null) {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please enter Start Date.',
            });
            return
        } else if ((date1 !== null && date2 !== null ) && date2.isBefore(date1)) {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message:
                    'End date time should be greater than Start date time.',
            });
            return;
        } else {
            setIsLoading(true);
            let subActParticipant = [];
            if (selected.length > 0) {
                selected.map((val) => {
                    subActParticipant.push({
                        subActivityParticipantID: props.activityInfo?.subActivityID ? props.activityInfo.subActivityID : 0,
                        subActivityID: props.activityInfo?.subActivityID ? props.activityInfo.subActivityID : 0,
                        userID: val,
                        createdBy: userInfo.attach(Downgraded).get().userID,
                        modifiedBy: userInfo.attach(Downgraded).get().userID,
                    })
                })
            }
            // console.log("sadasd",state.get().startDateTime,state.get(), state.get().startDateTime != "" ? "here" : "there");
             let payLoad = {
                subActivityID: props.activityInfo?.subActivityID ? props.activityInfo.subActivityID : 0,
                activityID: props.activityInfo
                    ? props.activityInfo.activityID
                    : 0,
                eventID: eventData.attach(Downgraded).get().eventID,
                subActivityName: state.get().eventName,
                startDateTime: moment(new Date()).format('YYYY-MM-DD') + 'T' + (state.get().startDateTime === "" || state.get().startDateTime === null ? "00:00" : state.get().startDateTime),
                    // state.get().startDateTime != ""
                    //     ? (moment(new Date()).format('YYYY-MM-DD') + 'T' + state.get().startDateTime === "" ? "00:00" : state.get().startDateTime)
                    //     : (moment(new Date()).format('YYYY-MM-DD') + 'T' + "00:00"),
                endDateTime: moment(new Date()).format('YYYY-MM-DD') + 'T' + (state.get().endDateTime === "" || state.get().endDateTime === null ? "00:00" : state.get().endDateTime),
                    // state.get().endDateTime !== ""
                    //     ? (moment(new Date()).format('YYYY-MM-DD') + 'T' + state.get().endDateTime === "" ? "00:00" : state.get().endDateTime)
                    //     : moment(new Date()).format('YYYY-MM-DD') + 'T' + "00:00",
                notes: state.get().notes,
                createdBy: userInfo.attach(Downgraded).get().userID,
                modifiedBy: userInfo.attach(Downgraded).get().userID,
                subActivityParticipants: subActParticipant
            };

            return ApiHelper.post(APIURLConstants.POST_SUB_ACTIVITY_LIST, payLoad)
                .then(() => {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: props.activityInfo
                            ? 'Sub Activity updated successfully.'
                            : 'Sub Activity created successfully.',
                    });
                    //let id = payLoad.participants !== null ? payLoad.participants[0].userID : 0;
                    props.handleClose();
                    props.getActivityList(0);
                    resetState();
                })
                .catch((err) => {
                    console.log(err);
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Error while adding activity.',
                    });
                });
        }
    };

    const resetState = () => {
        state.set({
            eventName: '',
            startDateTime: null,
            endDateTime: null,
        });
    };
    return (
        <CustomDialog
            title={props.activityInfo?.subActivityID ? 'EDIT NEW SUB ACTIVITY' : 'CREATE NEW SUB ACTIVITY'}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
        />
    );
};
export default AddSubAcctivity;
